import React, { memo } from 'react';
import PropTypes from 'prop-types';
import NumberFormatter from 'admin/utils/NumberFormatter';
import "./style.scss";
import {
   MediaButton,
   MediaMemberBottonOptions,
   MediaDashboardBottonOptions,
} from 'common/components/modules/media';

const StoryBottomContent = ({
   commentsCount,
   hasAccess,
   classNames,
   onClickLike,
   viewCount,
   likeCount,
   isAdmin,
   onClickOptions,
   isLiked,
   isAuthUsers,
   isMultiple,
   openStoryComments,
   onClickTip,
   id,
   totalTip,
   onClickOpenTips,
   onClickSetId,
   data,
   onShare,
   siteInfo,
}) => {
   const numberFormatter = new NumberFormatter();
   const onClick = (e) => {
      e.stopPropagation()
      onClickTip(true, {
         "resource_id": id,
         "resource_type": 'story',
      });
   }

   if(isAdmin) {
      const canShowViewsCount = Boolean(siteInfo?.views);
      const canShowLikesCount = Boolean(siteInfo?.like);
      // const canShowCommentsCount = Boolean(siteInfo?.total_comment_counts);
      const canShowCommentsCount = true;
      const canShowTotalTip = Boolean(siteInfo?.tip);
      const showCounts = canShowViewsCount || canShowLikesCount || canShowCommentsCount || canShowTotalTip;
      return (
         <div className='flex justify-between z-10 absolute bottom-0 left-0 w-full'>
            {
               showCounts && (
                  <MediaDashboardBottonOptions
                     canShowViewsCount={ canShowViewsCount }
                     canShowLikesCount={ canShowLikesCount }
                     canShowCommentsCount={ canShowCommentsCount }
                     canShowTotalTip={ canShowTotalTip }
                     viewsCount={ viewCount }
                     likesCount={ likeCount }
                     commentsCount={ commentsCount }
                     totalTip={ totalTip }
                     // disabled={ disabled }
                     sentTip={ () => {
                        onClickSetId(data.id)
                        onClickOpenTips()
                     } }
                     onClickComment={ openStoryComments }
                  />

               )
            }
            <MediaButton
               iconName='optons-horizontal'
               onClick={ (e) => {
                  onClickOptions(isMultiple)
               } }
               fontIconSize='2xl'
               className='ml-auto mr-2 mb-2'
            />
         </div>
      )
   } else {
      const canSendTip = siteInfo?.tip && isAuthUsers;
      const canShare = siteInfo?.share;
      const canLike = siteInfo?.like && isAuthUsers;
      return (
         <div className='flex justify-between px-2 pb-2'>
            {
               !!data?.can_read_comments &&
               <MediaButton
                  iconName='comment'
                  onClick={ (e) => {
                     openStoryComments();
                  } }
                  text={ `${ siteInfo?.total_comment_counts ? (!!commentsCount ? commentsCount === 1 ? commentsCount + ' comment' : numberFormatter.withCommas(commentsCount) + ' comments' : '') : '' }` }
               />
            }

            {
               hasAccess && (canLike || canShare || canSendTip)  && (

                  <MediaMemberBottonOptions
                     isLiked={ isLiked }
                     id={ id }
                     onClickLike={ onClickLike }
                     canLike={ canLike }
                     canShare={ canShare }
                     canSendTip={ canSendTip }
                     canChangeFavorite={ false }
                     onShare={ _ => onShare(id, 'story') }
                     onClickTip={ onClick }
                     collectionType='story'

                  />
               )
            }
         </div>
      );
   }
};

StoryBottomContent.propTypes = {
   commentsCount: PropTypes.number,
   viewCount: PropTypes.number,
   likeCount: PropTypes.number,
   hasAccess: PropTypes.any,
   isAdmin: PropTypes.bool,
   isLiked: PropTypes.bool,
   isAuthUsers: PropTypes.bool,
   isMultiple: PropTypes.bool,
   classNames: PropTypes.string,
   onClickLike: PropTypes.func,
   onClickOptions: PropTypes.func,
   openStoryComments: PropTypes.func,
   onClickTip: PropTypes.func,
   id: PropTypes.number,
   totalTip: PropTypes.number,
   onClickOpenTips: PropTypes.func,
   onClickSetId: PropTypes.func,
   data: PropTypes.object,
   onShare: PropTypes.func,
   siteInfo: PropTypes.object,
};

export default memo(StoryBottomContent);
